import { utils, writeFile } from 'xlsx';

export function exportToXLSX(csvData: any, fileName: string) {
    const ws = utils.json_to_sheet(csvData);
    const wb = utils.book_new();
    utils.book_append_sheet(wb, ws, "Data");
    writeFile(wb, `${fileName}.xlsx`);
}

export function exportToCSV(csvData: any, fileName: string) {
    const ws = utils.json_to_sheet(csvData);
    const wb = utils.book_new();
    utils.book_append_sheet(wb, ws, "Data");
    writeFile(wb, `${fileName}.csv`);
}
